import { ReactElement } from 'react';
import { ChartList } from '../chart/chart-list';
import './team.css';

interface TeamHomeProps {
  id: string;
}

const TeamHome = (props: TeamHomeProps): ReactElement => {
  const { id } = props;

  return <ChartList parentId={id} />;
};

export { TeamHome };
